import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'appointments.title',
    defaultMessage: 'Appointments',
  },
  fnbTitle: {
    id: 'appointments.fnb-title',
    defaultMessage: 'Orders',
  },
  noAppointments: {
    id: 'appointments.no-appointments',
    defaultMessage: 'No appointments found.',
  },
  noAppointmentsSubtitle: {
    id: 'appointments.no-appointments-subtitle',
    defaultMessage: 'Your new appointments will appear here as ClassPass members book them.',
  },
  noOrders: {
    id: 'appointments.no-orders',
    defaultMessage: 'No orders found.',
  },
  noOrdersSubtitle: {
    id: 'appointments.no-orders-subtitle',
    defaultMessage: 'Your new orders will appear here as ClassPass customers book them.',
  },
  today: {
    id: 'appointments.appointments-summary.today',
    defaultMessage: 'Today, {date, date, medium-no-year}',
  },
  upcomingBlocks: {
    id: 'appointments.appointments-summary.upcoming-blocks',
    defaultMessage: 'Upcoming blocks',
  },
  addBlock: {
    id: 'appointments.block-off-time.add-block',
    defaultMessage: 'Add block',
  },
  addStaffBlock: {
    id: 'appointments.block-off-time.add-staff-block',
    defaultMessage: 'Add staff block',
  },
  manageCalendarLinks: {
    id: 'appointments.manage-calendar-links',
    defaultMessage: 'Manage Calendar Sync',
  },
});

export const CancelAppointmentMessages = defineMessages({
  title: {
    id: 'appointments.cancel-appointment.title',
    defaultMessage: 'Cancel this appointment',
  },
  fnbTitle: {
    id: 'appointments.cancel-appointment.fnb-title',
    defaultMessage: 'Cancel this order',
  },
  reasonCardTitle: {
    id: 'appointments.cancel-appointment.reason-card-title',
    defaultMessage: 'Specify cancellation reason',
  },
  placeholder: {
    id: 'appointments.cancel-appointment.placeholder',
    defaultMessage: 'Share why you cannot fulfill this appointment and any other helpful details',
  },
  back: {
    id: 'appointments.cancel-appointment.back',
    defaultMessage: 'Back',
  },
  messages: {
    id: 'appointments.cancel-appointment.messages',
    defaultMessage: 'Client message',
  },
  cancelAppointment: {
    id: 'appointments.cancel-appointment.cancel-appointment',
    defaultMessage: 'Cancel appointment',
  },
  cancelOrder: {
    id: 'appointments.cancel-appointment.cancel-order',
    defaultMessage: 'Cancel order',
  },
  cancelReasonPlaceholder: {
    id: 'appointments.cancel-appointment.cancel-reason-placeholder',
    defaultMessage: 'Please select cancellation reason',
  },
  cancelReasonDescriptionPlaceholder: {
    id: 'appointments.cancel-appointment.cancel-reason-description-placeholder',
    defaultMessage: 'Please describe why you cannot fulfill this appointment',
  },
  buttonBack: {
    id: 'appointments.cancel-appointment.button-back',
    defaultMessage: 'Appointments',
  },
  createStaffBlock: {
    id: 'appointments.cancel-appointment.create-staff-block',
    defaultMessage: 'We will create a staff block for you',
  },
  staffBlock: {
    id: 'appointments.cancel-appointment.staff-block',
    defaultMessage: '{teacherName} unavailable {startDateTime, date, time} - {endDateTime, date, time}',
  },
  blockSelectedDays: {
    id: 'appointments.cancel-appointment.block-selected-days',
    defaultMessage: 'Make all other times unavailable to book for all users on the selected date(s)',
  },
  altTimeHeader: {
    id: 'appointments.cancel-appointment.alternative-start-time-header',
    defaultMessage: 'Suggest new appointment time',
  },
  altTimeDescription: {
    id: 'appointments.cancel-appointment.alternative-start-time-description',
    defaultMessage:
      'We will send the client a link to reschedule this appointment with your suggested times. {br}<strong>*Note that selected times will override existing blocks on your calendar.</strong>',
  },
  staffBlockHeader: {
    id: 'appointments.cancel-appointment.staff-block-header',
    defaultMessage: 'Staff block',
  },
  staffBlockDescription: {
    id: 'appointments.cancel-appointment.staff-block-description',
    defaultMessage: 'We will automatically create a staff block for the original time of this appointment. ',
  },
  sendMessageToUser: {
    id: 'appointments.cancel-appointment.send-message-to-user',
    defaultMessage: 'Use the text box below to include a custom message to {userName}.',
  },
  deleteService: {
    id: 'appointments.cancel-appointment.delete-service',
    defaultMessage: 'Delete service',
  },
});

export const sagaMessages = {
  error: defineMessages({
    userHasCancelledAppointment: {
      id: 'appointments.saga.error.user-has-canceled-appointment',
      defaultMessage: "Can't send an email. User has canceled the appointment.",
    },
    cannotUpdateCalendarData: {
      id: 'appointments.saga.error.cannot-update-calendar-data',
      defaultMessage: 'There was a problem marking the user’s attendance. Please try again.',
    },
    cannotCancelReservation: {
      id: 'appointments.saga.error.cannot-cancel-reservation',
      defaultMessage: 'There was a problem canceling an appointment. Please try again.',
    },
    cannotDetachService: {
      id: 'appointments.saga.error.cannot-detach-service',
      defaultMessage: 'There was a problem deleting a service. Please try again.',
    },
    genericError: {
      id: 'appointments.error',
      defaultMessage: 'Something went wrong... Try again later on.',
    },
    cannotUpdatePhoneNumber: {
      id: 'appointments.saga.error.cannot-update-phone-number',
      defaultMessage: 'An error occurred while trying to update phone number. Please try again.',
    },
  }),
  success: defineMessages({
    appointmentCancelled: {
      id: 'appointments.manage-calendary-links',
      defaultMessage: 'Appointment Canceled',
    },
    appointmentAlternativeTimeSaved: {
      id: 'appointments.saga.success.appointment-alternative-time-saved',
      defaultMessage: 'The appointment has been canceled',
    },
    serviceDetached: {
      id: 'appointments.saga.success.appointment-service-detached',
      defaultMessage: 'The service has been deleted.',
    },
    userMessageInitiated: {
      id: 'appointments.saga.success.user-message',
      defaultMessage:
        'Conversation initiated. Reply to the message you just received from ClassPass to contact this member about their reservation.',
    },
    phoneNumberUpdated: {
      id: 'appointments.saga.success.phone-number-updated',
      defaultMessage: 'Your phone number has been updated.',
    },
  }),
};

export const cancelReasonOptionMessages = defineMessages({
  doubleBookedNoOtherAvailable: {
    id: 'appointments.cancel-appointment.cancellation-reason.practitioner-double-booked-no-other-available',
    defaultMessage:
      '{teacherName, select, undefined {Double booked} other {{teacherName} double booked}} (no others are available)',
  },
  doubleBookedNeedToAssignOther: {
    id: 'appointments.cancel-appointment.cancellation-reason.practitioner-double-booked-need-to-assign-other',
    defaultMessage:
      '{teacherName, select, undefined {Double booked} other {{teacherName} double booked}} (need to reassign appointment)',
  },
  practitionerUnavailableAtThisTime: {
    id: 'appointments.cancel-appointment.cancellation-reason.practitioner-unavailable-at-this-time',
    defaultMessage: '{teacherName, select, undefined {Unavailable} other {{teacherName} unavailable}} at this time',
  },
  practitionerMaxReservationsNumberReached: {
    id: 'appointments.cancel-appointment.cancellation-reason.practitioner-max-reservations-number-reached',
    defaultMessage:
      '{teacherName, select, undefined {Maximum number} other {{teacherName} maximum number}} of reservations reached',
  },
  directBookingWithHigherPriority: {
    id: 'appointments.cancel-appointment.cancellation-reason.direct-booking-with-higher-priority',
    defaultMessage: 'Direct booking/walk-in took priority',
  },
  serviceShouldNotBeOnClassPass: {
    id: 'appointments.cancel-appointment.cancellation-reason.service-should-not-be-on-classpass',
    defaultMessage: "Service shouldn't be offered on ClassPass",
  },
  serviceNoLongerAvailable: {
    id: 'appointments.cancel-appointment.cancellation-reason.service-is-no-longer-available',
    defaultMessage: 'Service is no longer offered',
  },
  locationClosed: {
    id: 'appointments.cancel-appointment.cancellation-reason.location-closed',
    defaultMessage: 'Location is closed',
  },
  other: {
    id: 'appointments.cancel-appointment.cancellation-reason.other',
    defaultMessage: 'Other (please specify)',
  },
});

export const AddVenueBlockModalMessages = defineMessages({
  title: {
    id: 'appointments.add-venue-block-modal.title',
    defaultMessage: 'Add Venue Block',
  },
  description: {
    id: 'appointments.add-venue-block-modal.description',
    defaultMessage: 'Would you like to add a venue closure to avoid additional reservations on this day?',
  },
  accept: {
    id: 'appointments.add-venue-block-modal.accept',
    defaultMessage: 'Yes',
  },
  cancel: {
    id: 'appointments.add-venue-block-modal.cancel',
    defaultMessage: 'No',
  },
});

export const appointmentsCalendarSyncCtaMessages = defineMessages({
  title: {
    id: 'appointments.calendar-sync-cta.title',
    defaultMessage: 'Prevent double booking with Calendar Sync',
  },
  copy: {
    id: 'appointments.calendar-sync-cta.copy',
    defaultMessage:
      'Now you can synchronize appointments between your main booking platform or calendar and ClassPass to avoiding double booking.',
  },
  button: {
    id: 'appointments.calendar-sync-cta.button',
    defaultMessage: 'Set Up Calendar Sync',
  },
});

export const AlternativeTimeMessages = defineMessages({
  formHeader: {
    id: 'appointments.alternative-time.form-header',
    defaultMessage:
      'Select all times that <strong>{teacherName}</strong> is available. (To remove appointment times for entire days, add that day and do not select any time slots.)',
  },
  addDate: {
    id: 'appointments.alternative-time.add-date',
    defaultMessage: 'Add another date',
  },
  dateLabel: {
    id: 'appointments.alternative-time.date-label',
    defaultMessage: 'Date',
  },
  selectTimeSlotsLabel: {
    id: 'appointments.alternative-time.select-time-slots-label',
    defaultMessage: 'Select time slots',
  },
  timeSlotsLabel: {
    id: 'appointments.alternative-time.time-slots-label',
    defaultMessage: 'Time slots',
  },
  xTimeSlotsSelected: {
    id: 'appointments.alternative-time.x-time-slots-selected',
    defaultMessage: '{timeSlotsNumber, plural, one {# time slot} other {# time slots}} selected',
  },
});

export const alternativeTimeConfirmationModalMessages = defineMessages({
  title: {
    id: 'appointments.alternative-time.confirmation-modal.title',
    defaultMessage: 'Confirm cancellation',
  },
  cancel: {
    id: 'appointments.alternative-time.confirmation-modal.cancel',
    defaultMessage: 'Cancel',
  },
  confirm: {
    id: 'appointments.alternative-time.confirmation-modal.confirm',
    defaultMessage: 'Confirm cancellation',
  },
  dateLabel: {
    id: 'appointments.alternative-time.confirmation-modal.date-label',
    defaultMessage: 'Date',
  },
  timeLabel: {
    id: 'appointments.alternative-time.confirmation-modal.time-label',
    defaultMessage: 'Time',
  },
  noneSelected: {
    id: 'appointments.alternative-time.confirmation-modal.none-selected',
    defaultMessage: 'None selected',
  },
  overrideStaffBlocks: {
    id: 'appointments.alternative-time.confirmation-modal.override-staff-blocks',
    defaultMessage: 'Suggested start times will override staff blocks.',
  },
  clientMessageHeader: {
    id: 'appointments.alternative-time.confirmation-modal.client-message-header',
    defaultMessage: 'Client message',
  },
  staffBlockHeader: {
    id: 'appointments.alternative-time.confirmation-modal.staff-block-header',
    defaultMessage: 'Staff {numberOfBlocks, plural, one {block} other {blocks}}',
  },
  staffBlockLabel: {
    id: 'appointments.alternative-time.confirmation-modal.staff-block-label',
    defaultMessage: '{startDateTime, date, medium-w-long-dow-no-year}:',
  },
  staffBlock: {
    id: 'appointments.alternative-time.confirmation-modal.staff-block',
    defaultMessage: '{teacherName} unavailable {startDateTime, date, time} - {endDateTime, date, time}',
  },
  suggestedTimesHeader: {
    id: 'appointments.alternative-time.confirmation-modal.suggested-times-header',
    defaultMessage: 'Suggested new appointment times',
  },
});

export const alternativeTimeLoadingModalMessages = defineMessages({
  title: {
    id: 'appointments.alternative-time.loading-modal.title',
    defaultMessage: 'Reservation cancellation in progress',
  },
  body: {
    id: 'appointments.alternative-time.loading-modal.body',
    defaultMessage: 'Reservation is being canceled. You will be redirected automatically once the process is finished.',
  },
});
